import { useMemo } from "react";

export const useVisiblePageRange = ({
  totalPages,
  currentPage,
  totalVisible = 7,
}: {
  totalPages: number;
  currentPage: number;
  totalVisible: number;
}) => {
  const pages = useMemo(() => {
    const allPages = [...Array(totalPages + 1).keys()].slice(1);
    const indexOfActive = allPages.indexOf(currentPage);

    let start = Math.max(indexOfActive - Math.floor(totalVisible / 2), 0);
    let end = start + totalVisible;

    if (end > totalPages) {
      end = totalPages;
      start = Math.max(end - totalVisible, 0);
    }

    return allPages.slice(start, end);
  }, [totalPages, currentPage, totalVisible]);
  return pages;
};
